export default {
	id: 'SIMPLE_WORKBOOK_EATING_GUILT_FREE_14_99',
	providers: {
		paltaMap: {
			USD: 'simple_workbook_eating_guilt_free_14_99_usd',
		},
		primer: 'prd_1L0f3Xdz4LIg',
	},
	otp: {
		priceMap: {
			USD: 14.99,
		},
	},
}
